import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'

export const getHourlyRate = createSelector(
  (state: SettingsRootState) => state.settingsStore,
  (state) => state.hourlyRate,
)
